import LeaseEndContainer from '../../components/Container/LEContainer';
import ButtonsRow from '../../components/Dashboards/ButtonsRow';
import StructuringFollowUpsTable from '../../components/StructuringFollowUp/StructuringFollowUpTable';

const StructuringFollowUpsPage = () => {
  return (
    <>
      <ButtonsRow />
      <LeaseEndContainer>
        <StructuringFollowUpsTable />
      </LeaseEndContainer>
    </>
  );
};

export default StructuringFollowUpsPage;
